/* THEONE — PDP proof + price layer.
   HARD RULE (hers): a line must land in ONE read. No arithmetic,
   no "per month you've been together". The money comparison also
   has to sit inside the brand's register — a sneaker comparison is
   instantly clear and instantly cheapens a 180 EUR bridal page.

   REMOVED on her call (Sept 7): the "One payment … the Vault stays
   free, forever" line under the buy buttons.
   REMOVED earlier: the "What buyers wrote" quote block. Its quotes,
   real and unedited, now belong on the story page:
     "She was so so so happy said its best gift I could ever have given" — Nik D.
     "No comment but beautiful and thank you i made her the happiest girl ever" — Naj D.
     "it's perfect looks like an engagement ring!!!" — miley k. */
(function () {
  var de = (document.documentElement.lang || '').slice(0, 2) === 'de';
  var it = (document.documentElement.lang || '').slice(0, 2) === 'it';

  function ready(f) {
    if (document.readyState !== 'loading') f();
    else document.addEventListener('DOMContentLoaded', f);
  }

  /* The luxe layer injects (and re-injects) the star row, so a
     one-shot rewrite gets clobbered. Re-apply until it sticks. */
  function countFirst() {
    var label = document.querySelector('.tl-stars__t');
    if (!label || label.querySelector('.tlv48-count')) return;
    var m = (label.textContent || '').match(/([\d.,]+)\s*[·•|]\s*([\d.,]+)/);
    if (!m) return;
    label.innerHTML = '<span class="tlv48-count">' + m[2] + (de ? ' Bewertungen' : it ? ' recensioni' : ' reviews')
      + '</span> · ' + m[1];
  }

  ready(function () {
    var main = document.querySelector('main');
    if (!main || main.dataset.template !== 'product') return;

    /* --- 1 · rating row: lead with the count, not the score --- */
    countFirst();
    window.addEventListener('load', countFirst);
    if ('MutationObserver' in window) {
      var tries = 0;
      var mo = new MutationObserver(function () {
        countFirst();
        if (++tries > 60) mo.disconnect();
      });
      mo.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { mo.disconnect(); }, 8000);
    }

    /* --- 2 · under the price: the money comparison --- */
    if (!document.querySelector('.tlv47-perwear')) {
      var priceEl = document.querySelector('.product-details .price, .product-details [class*="price"]');
      if (priceEl) {
        var host = priceEl.closest('[class*="price"]') || priceEl;
        var w = document.createElement('span');
        w.className = 'tlv47-perwear';
        w.textContent = de
          ? 'Ein Abendessen zu zweit. Oder ein Ring, den sie nie mehr ablegt.'
          : it ? 'Una cena fuori. O un anello che lei non toglierà mai.'
          : 'One dinner out. Or a ring she never takes off.';
        host.parentNode.insertBefore(w, host.nextSibling);
      }
    }

    /* --- 2b · free shipping, read in the same glance as the price.
       Country-gated: the EU zone ships free with DPD, and since 9 Oct
       2026 the US rate is free as well ("Standard", 0.00 in Settings >
       Shipping). UK/NO still pay a rate, so those visitors never see a
       line that is not true for them. --- */
    var EU = 'AT,BE,BG,HR,CY,CZ,DK,EE,FI,FR,DE,GR,HU,IE,IT,LV,LT,LU,MT,NL,PL,PT,RO,SK,SI,ES,SE'.split(',');
    var country = (window.Shopify && window.Shopify.country) || '';
    var isUS = country === 'US';
    if ((isUS || EU.indexOf(country) !== -1) && !document.querySelector('.tlv50-ship')) {
      var shipHost = document.querySelector('.tlv47-perwear')
        || document.querySelector('.product-details .price, .product-details [class*="price"]');
      if (shipHost) {
        var sh = document.createElement('span');
        sh.className = 'tlv50-ship';
        sh.innerHTML = '<b>&#10003;</b>' + (isUS
          ? 'Free shipping across the US · Tracked to your door'
          : de ? 'Kostenloser Versand in der ganzen EU · DPD mit Sendungsverfolgung'
          : it ? 'Spedizione gratuita in tutta l’UE · Tracciata con DPD'
          : 'Free shipping across the EU · Tracked with DPD');
        shipHost.parentNode.insertBefore(sh, shipHost.nextSibling);
      }
    }
  });
})();